import { render, staticRenderFns } from "./GeneralCursos.vue?vue&type=template&id=70469eb1&scoped=true"
import script from "./GeneralCursos.vue?vue&type=script&lang=js"
export * from "./GeneralCursos.vue?vue&type=script&lang=js"
import style0 from "./GeneralCursos.vue?vue&type=style&index=0&id=70469eb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70469eb1",
  null
  
)

export default component.exports